
    <ngx-smart-modal #myModal1 identifier="myModal1">
        <h2 class="modalError">Please login and subscribe to access this content.</h2>
        <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
      </ngx-smart-modal>
      <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
        <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
        <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
      </ngx-smart-modal> -->
      <div class="loadingBox" *ngIf="!loaded">
        <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
       </div>
      <app-header></app-header>
    <div id="wrapper">
        <app-sidebar></app-sidebar>
        <div class="single-channel-page" id="content-wrapper">
            <div class="single-channel-nav">
                <nav class="navbar navbar-light bg-faded justify-content-between flex-nowrap flex-row">
                    <div class="container">
                        <span i18n="@@My List | My List Page Title" class="channel-brand mylist">
                            <i class="fas fa-fw fa-heart text-success"></i>My List
                        </span>
                    </div>
                </nav>

            </div>

            <div class="container-fluid">
                <div class="video-block section-padding">
                    <div class="tab-slider--body">
                        <div class="container">
                            <div class="row">

                                <div class="tab-slider--container">
                                    <div class="tab-slider--body">
                                        <div class="container">
                                            <app-fav-snippet></app-fav-snippet>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <br/>
                        <div class="tab-slider--body">
                            <div class="container">
                                <div class="row">
                                    <div class="tab-slider--container">
                                        <div class="tab-slider--body">
                                            <div class="container">
                                                    <app-later-snippet></app-later-snippet>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
                <!-- Sticky Footer -->
            </div>
        </div>
        <br/>
        <br/>
        <br/>
        <div class="navbarbottom">
            <a routerLink="/">
                <i _ngcontent-c3="" class="fas fa-fw fa-home"></i>
                <span class="homeFooterLink" i18n="@@Footer Home Link">Home</span>
            </a>
            <a routerLink="/my-list">
                <i _ngcontent-c3="" class="fas fa-fw fa-list"></i>
                <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span>
            </a>
        </div>